import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import Typography from '@components/basics/typography';
import RefLabel from './ref-label';

interface AnalyticsIndicatorProps {
  className?: string;
  label: number;
  refText: string;
  textTop?: boolean;
  isVertical?: boolean;
}

const AnalyticsIndicator: FunctionComponent<AnalyticsIndicatorProps> = ({
  className,
  label,
  refText,
  isVertical,
}) => {
  return (
    <div className={className || ''}>
      <RefLabel label={refText} marginBottom />
      <MetricHeader className={isVertical ? 'vertical' : ''}>
        <Typography customFont="medium" className={'metric-number'}>
          {Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            //@ts-ignore
            notation: 'compact',
            compactDisplay: 'short',
          }).format(label)}
        </Typography>
      </MetricHeader>
    </div>
  );
};

export default styled(AnalyticsIndicator)``;

const MetricHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0px;

  &.vertical {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .metric-number {
    font-size: 18px;
    font-weight: 600;
    line-height: 21.6px;
  }
`;
